/**
 * Branchen der LinkedIn-Suche (deutsche Bezeichnungen, alphabetisch) für die Branchenauswahl in Schritt 2.
 * Nur Branchen, für die die API eine LinkedIn-Branchen-ID kennt. Quelle und ID-Zuordnung:
 * packages/api/src/modules/campaign-wizard/wizard-industries.data.ts (ein Test hält beide Listen gleich).
 */
export const WIZARD_INDUSTRIES: readonly string[] = [
  'Abbau nicht-metallischer Mineralien',
  'Abfallbehandlung und -entsorgung',
  'Abfallsammlung',
  'Alternative Medizin',
  'Alternative Streitbeilegung',
  'Ambulante Versorgungszentren',
  'Ämter für öffentliche Ordnung',
  'Animation',
  'Animation und Postproduktion',
  'Anlageberatung',
  'Architektur und Planung',
  'Arzneimittelherstellung',
  'Ärzte',
  'Arztpraxen',
  'Ausrüstungsverleih',
  'Autobahn-, Straßen- und Brückenbau',
  'Automobil',
  'Außenhandel und internationale Entwicklung',
  'Bankwesen',
  'Barrierefreie Architektur und barrierefreies Design',
  'Bars und Nachtclubs',
  'Bau von Versorgungssystemen',
  'Bauausführende Unternehmen',
  'Baugewerbe',
  'Baumaterialien',
  'Bed and Breakfasts, Jugendherbergen, Privatunterkünfte',
  'Beherbergung und Gastronomie',
  'Behördenbeziehungen',
  'Bekleidung & Mode',
  'Bekleidungsherstellung',
  'Bergbau',
  'Berufliche Rehabilitationsdienste',
  'Berufsverbände',
  'Besichtigungsfahrten',
  'Betrieb und Wartung von IT-Systemen',
  'Beziehung zu Regierungen',
  'Bibliothekswesen',
  'Bildungsmanagement',
  'Bildungsverwaltungsprogramme',
  'Bildungswesen',
  'Biotechnologie',
  'Biotechnologieforschung',
  'Blockchain-Dienste',
  'Blogs',
  'Branchenverbände',
  'Brandschutz',
  'Brauereien',
  'Brennereien',
  'Buchverlage',
  'Büromaterial und -ausstattung',
  'Büroverwaltung',
  'Business-Intelligence-Plattformen',
  'Busnahverkehr',
  'Busverkehr für Schulen und Arbeitnehmer',
  'Caterer',
  'Chemische Produktion',
  'Chiropraktiker',
  'Computer- und Netzwerksicherheit',
  'Computer-Hardware',
  'Computer-Netzwerke',
  'Computerspiele',
  'Dampf-, Wärme- und Kälteversorgung',
  'Darlehensvermittler',
  'Darstellende Künste',
  'Darstellende Künste und Zuschauersport',
  'Datendienste für IT-Systeme',
  'Dateninfrastruktur und -analytik',
  'Denkfabrik',
  'Design',
  'Designdienstleistungen',
  'Designdienstleistungen für IT-Systeme',
  'Dienste für ältere und behinderte Menschen',
  'Dienste für digitale Barrierefreiheit',
  'Dienstleistungen für erneuerbare Energien',
  'Dienstleistungen für Haustiere',
  'Dienstleistungen für Verbraucher',
  'Drahtlose Dienste',
  'Druckdienstleistungen',
  'E-Learning',
  'E-Learning-Anbieter',
  'Eingebettete Software',
  'Einzelhandel',
  'Einzelhandel: Baustoffe und Gartengeräte',
  'Einzelhandel: Bekleidung und Mode',
  'Einzelhandel: Blumen',
  'Einzelhandel: Bücher und Presse',
  'Einzelhandel: Büroausstattung',
  'Einzelhandel: Bürobedarf und Geschenkartikel',
  'Einzelhandel: Gesundheits- und Körperpflegeprodukte',
  'Einzelhandel: Haushalts-, Elektro- und Elektronikgeräte',
  'Einzelhandel: Kraftfahrzeuge',
  'Einzelhandel: Kraftstoffe',
  'Einzelhandel: Künstlerbedarf',
  'Einzelhandel: Kunstwerke',
  'Einzelhandel: Lebensmittel',
  'Einzelhandel: Luxusgüter und Schmuck',
  'Einzelhandel: Möbel und Einrichtungsgegenstände',
  'Einzelhandel: Musikinstrumente',
  'Einzelhandel: Nahrungsmittel und Getränke',
  'Einzelhandel: Online- und Versandhandel',
  'Einzelhandel: Wiederverwertbare Materialien & Gebrauchtwaren',
  'Einzelhandelsapotheken',
  'Entertainment-Anbieter',
  'Entwicklung kundenspezifischer IT-Systemsoftware',
  'Erdgasgewinnung',
  'Erdgasverteilung',
  'Erdöl und Gas',
  'Erdöl, Gas und Bergbau',
  'Erdölförderung',
  'Erneuerbare Energie & Umwelt',
  'Erneuerbare Energien und Halbleiterproduktion',
  'Exekutivbehörden',
  'Fahrzeugbau',
  'Fahrzeugreparatur und -wartung',
  'Familienplanungszentren',
  'Fertigung',
  'Fertigung barrierefreier Hardware',
  'Fertigung für Verteidigung und Raumfahrt',
  'Fertigung von Kfz-Teilen',
  'Film, Video und Ton',
  'Filme und Tonaufnahmen',
  'Finanzdienstleistungen',
  'Fischerei',
  'Fluggesellschaften und Luftfahrt',
  'Flugtraining',
  'Fonds und Stiftungen',
  'Forschung',
  'Forschungsdienstleistungen',
  'Forst- und Holzwirtschaft',
  'Fotografie',
  'Fracht- und Pakettransport',
  'Freiberufliche Dienstleistungen',
  'Freizeiteinrichtungen',
  'Fundraising',
  'Fundraising für gute Zwecke',
  'Gaming-Apps für Mobilgeräte',
  'Gartenbau',
  'Gastronomie und Getränkeservice',
  'Gebäudebau',
  'Gebäudeservices',
  'Gemeindeentwicklung und Stadtplanung',
  'Gemeinnützige Arbeit',
  'Gemeinnützige Organisationen',
  'Gerichtshöfe',
  'Gesetzesvollzug',
  'Gesundheit, Wellness & Fitness',
  'Gesundheits- und Sozialwesen',
  'Getränkeherstellung',
  'Gewerbeimmobilien',
  'Golfplätze und Country-Clubs',
  'Grafikdesign',
  'Großhandel',
  'Großhandel: Alkoholische Getränke',
  'Großhandel: Arzneimittel und sonstige Drogerieartikel',
  'Großhandel: Baustoffe',
  'Großhandel: Bekleidung und Nähbedarf',
  'Großhandel: Computerausrüstung',
  'Großhandel: Eisenwaren, Sanitär, Heizgeräte',
  'Großhandel: Erdöl und Erdölerzeugnisse',
  'Großhandel: Erzeugnisse der chemischen Industrie oder verwandter Industrien',
  'Großhandel: Fahrzeuge und Fahrzeugteile',
  'Großhandel: Fotoausrüstung und Zubehör',
  'Großhandel: Haushalts-, Elektro- und Elektronikgeräte',
  'Großhandel: Import und Export',
  'Großhandel: Landwirtschaftliche Rohprodukte',
  'Großhandel: Luxusgüter und Schmuck',
  'Großhandel: Maschinen',
  'Großhandel: Metalle und Mineralien',
  'Großhandel: Möbel und Einrichtungsgegenstände',
  'Großhandel: Nahrungsmittel und Getränke',
  'Großhandel: Papierprodukte',
  'Großhandel: Schuhe',
  'Großhandel: Wiederverwertbare Materialien',
  'Grund- und Sekundarschulen',
  'Grundflächenparzellierung',
  'Halbleiter',
  'Haushaltsnahe Dienstleistungen',
  'Häusliche Krankenpflege',
  'Hausmeisterdienste',
  'Herstellung elektrischer Lampen und Leuchten',
  'Herstellung Intelligenter Zähler',
  'Herstellung magnetischer und optischer Datenträger',
  'Herstellung medizinischer Geräte',
  'Herstellung von Anlagen für erneuerbare Energien',
  'Herstellung von Audio- und Videogeräten',
  'Herstellung von Automatisierungsanlagen',
  'Herstellung von Backwaren',
  'Herstellung von Bahnfahrzeugen und Fahrzeugteilen',
  'Herstellung von Baubeschlägen',
  'Herstellung von Bauteilen für die Luft- und Raumfahrt',
  'Herstellung von Besteck- und Handwerkzeugen',
  'Herstellung von Brennstoffzellen',
  'Herstellung von Büro- und Geschäftsausstattung',
  'Herstellung von Computerhardware',
  'Herstellung von Computern und Elektronik',
  'Herstellung von Damenhandtaschen',
  'Herstellung von Drehteilen und Verschlüssen',
  'Herstellung von Elektrogeräten',
  'Herstellung von Fahrzeugen mit Alternativem Kraftstoff',
  'Herstellung von Farben, Beschichtungen und Klebstoffen',
  'Herstellung von Feder- und Drahtprodukten',
  'Herstellung von Fleischwaren',
  'Herstellung von Gewerbe- und Dienstleistungsmaschinen',
  'Herstellung von Glas, Keramik und Beton',
  'Herstellung von Glasprodukten',
  'Herstellung von Gummiprodukten',
  'Herstellung von Halbleitern',
  'Herstellung von Haushalts- und Objektmöbeln',
  'Herstellung von Haushalts-, Elektro- und Elektronikgeräten',
  'Herstellung von Haushaltsgeräten',
  'Herstellung von Holzwaren',
  'Herstellung von Industriemaschinen',
  'Herstellung von Kalk- und Gipsprodukten',
  'Herstellung von Kesseln und Metallbehältern',
  'Herstellung von Klima- und Umwelttechnologieprodukten',
  'Herstellung von Klimatechnik',
  'Herstellung von Kommunikationsgeräten',
  'Herstellung von Körperpflegeprodukten',
  'Herstellung von künstlichem Gummi und synthetischen Fasern',
  'Herstellung von Kunststoffen',
  'Herstellung von Kunststoffen und Gummiprodukten',
  'Herstellung von Landwirtschafts-, Bau- und Bergbaumaschinen',
  'Herstellung von Lederwaren',
  'Herstellung von Matratzen, Rollos und Jalousien',
  'Herstellung von Meeresfrüchteprodukten',
  'Herstellung von Mess- und Steuerinstrumenten',
  'Herstellung von Metallbearbeitungsmaschinen',
  'Herstellung von Metallerzeugnissen',
  'Herstellung von Metallkonstruktionen für den Architektur- und Baubereich',
  'Herstellung von Metallventilen, - kugeln und -walzen',
  'Herstellung von Milchprodukten',
  'Herstellung von Möbeln und Einrichtungsgegenständen',
  'Herstellung von Modeaccessoires',
  'Herstellung von Motoren und Kraftübertragungsgeräten',
  'Herstellung von Obst- und Gemüsekonserven',
  'Herstellung von Öl- und Kohleprodukten',
  'Herstellung von Papier- und Forstprodukten',
  'Herstellung von Planzenschutz- und Düngemittel',
  'Herstellung von Primärmetallen',
  'Herstellung von Schleifmitteln und nicht-metallischen Mineralien',
  'Herstellung von Seifen und Reinigungsmitteln',
  'Herstellung von Sportartikeln',
  'Herstellung von Tabakwaren',
  'Herstellung von Ton und feuerfesten Produkten',
  'Herstellung von Transportausrüstung',
  'Herstellung von Verpackungen und Behältnissen',
  'Historische Sehenswürdigkeiten',
  'Hochschulen und Universitäten',
  'Holdinggesellschaften',
  'Hotel- und Gaststättengewerbe',
  'Hotels und Motels',
  'Immobilien',
  'Immobilienmakler',
  'Import und Export',
  'Individual- und Familiendienstleistungen',
  'Industrielle Automatisierung',
  'Informationsdienste',
  'Ingenieurdienstleistungen',
  'Inkassounternehmen',
  'Innenarchitektur',
  'Installation und Entsorgung von IT-Systemen',
  'Internationale Angelegenheiten',
  'Internet-Publishing',
  'Internetnachrichten',
  'Investment Banking',
  'Investment Management',
  'IT und Services',
  'IT-Dienstleistungen und IT-Beratung',
  'Justizverwaltung',
  'Kabel- und Satellitenprogramme',
  'Kapitalmärkte',
  'Kindertagesbetreuung',
  'Klimadaten und Klimadatenanalytik',
  'Kohlebergbau',
  'Konsumgüter',
  'Kosmetik',
  'Kosmetik- und Friseurschulen',
  'Krankenhäuser',
  'Krankenhäuser und Gesundheitseinrichtungen',
  'Krankentransport',
  'Kreditvermittlung',
  'Kunstgewerbe',
  'Kunsthochschulen',
  'Künstler und Autoren',
  'Lagerhaltung',
  'Landschaftsbau',
  'Landwirtschaft',
  'Landwirtschaft, Viehwirtschaft, Forstwirtschaft',
  'Lebensmittel & Getränke',
  'Lebensmittelherstellung',
  'Legislativbehörden',
  'LKW-Transport',
  'Luft- & Raumfahrt',
  'Luxusgüter & Schmuck',
  'Management von Nonprofit-Organisationen',
  'Marketingdienstleistungen',
  'Marktforschung',
  'Maschinenbau',
  'Maschinenbau & Betriebstechnik',
  'Medien und Telekommunikation',
  'Medienproduktion',
  'Medizinische und diagnostische Labore',
  'Medizintechnik',
  'Metallbehandlung',
  'Metallerzbergbau',
  'Milchwirtschaft',
  'Militärische- und internationale Angelegenheiten',
  'Möbel',
  'Mobile Lebensmitteldienste',
  'Museen',
  'Museen, historische Sehenswürdigkeiten und Zoos',
  'Musik',
  'Musiker',
  'Musikverlage für Noten und Partituren',
  'Nahrungsmittel- und Getränkeherstellung',
  'Nanotechnologieforschung',
  'Naturschutzprogramme',
  'Neupolsterung und Möbelreparaturen',
  'Nichtwohnungsbau',
  'Notfall- und Hilfsdienste',
  'Öffentliche Hilfsprogramme',
  'Öffentliche Ordnung',
  'Öffentliche Sicherheit',
  'Öffentliches Gesundheitswesen',
  'Öffentlichkeitsarbeit und Kommunikationsdienste',
  'Online Audio- und Videomedien',
  'Online-Medien',
  'Operations Consulting',
  'Optiker',
  'Outsourcing & Offshoring',
  'Outsourcing und Offshoring Beratung',
  'Papier & Forstprodukte',
  'Personalbesetzung und Rekrutierung',
  'Personaldienstleistungen',
  'Personalwesen',
  'Personenbeförderung am Boden',
  'Persönliche Pflegedienste',
  'Persönliche- und Wäschereidienstleistungen',
  'Pflegeeinrichtungen',
  'Philanthropie',
  'Physio-, Ergo- und Sprachtherapeuten',
  'Plattformen für Internethandel',
  'Politische Organisationen',
  'Postdienstleistungen',
  'Produktion und Verbreitung von Rundfunkmedien',
  'Produktion von chemischen Rohstoffen',
  'Programmentwicklung',
  'Prüfung und Bewertung von IT-Systemen',
  'Psychische Gesundheitsfürsorge',
  'Radio- und Fernsehrundfunk',
  'Rechnungswesen',
  'Rechtsdienstleistungen',
  'Rechtskanzleien',
  'Regeneratives Design',
  'Regierungsverwaltung',
  'Reisebürodienstleistungen',
  'Religiöse Einrichtungen',
  'Rennstrecken',
  'Renten- und Pensionskassen',
  'Reparatur und Wartung',
  'Restaurants',
  'Roboterfertigung',
  'Robotik',
  'Rohrleitungstransport',
  'Satellitengestützte Telekommunikation',
  'Schadensabwicklung und Versicherungsdienstleistungen',
  'Schienenverkehr',
  'Schiffbau',
  'Schöne Künste',
  'Schuh- und Lederwarenreparatur',
  'Schuhherstellung',
  'Seefahrt',
  'Seeverkehr',
  'Sekretariatsschulen',
  'Shuttles und Sonderbeförderungen',
  'Sicherheits- und Ermittlungsdienste',
  'Sicherheits- und Wachpersonal',
  'Sicherheitssystemdienste',
  'Skianlagen',
  'Social-Networking-Plattformen',
  'Software für Computervernetzung',
  'Software für Datensicherheit',
  'Software für Desktopcomputer',
  'Software für Mobilgeräte',
  'Softwareentwicklung',
  'Soziale Netzwerke/Soziale Medien',
  'Sparkassen',
  'Spezialunternehmer',
  'Spielsalons und Casinos',
  'Sport- und Freizeitunterricht',
  'Sportartikel',
  'Sportmannschaften und -vereine',
  'Sprachschulen',
  'Städtischer Nahverkehr',
  'Strafvollzugsanstalten',
  'Strategieberatung',
  'Streitkräfte',
  'Stromerzeugung',
  'Stromerzeugung aus Biomasse',
  'Stromerzeugung aus Erdwärme',
  'Stromerzeugung aus erneuerbaren Energien',
  'Stromerzeugung aus fossilen Brennstoffen',
  'Stromerzeugung aus Kernkraft',
  'Stromerzeugung aus Solarenergie',
  'Stromerzeugung aus Wasserkraft',
  'Stromerzeugung aus Windkraft',
  'Tabak',
  'Tanzgruppen',
  'Taxi-, Kleinbus- und Limousinentransport',
  'Technische und berufliche Bildung',
  'Technologie, Information und Internet',
  'Technologie, Information und Medien',
  'Telefon-Callcenter',
  'Telekommunikation',
  'Telekommunikationsanbieter',
  'Text und Lektorat',
  'Textilherstellung',
  'Theatergruppen',
  'Tiefbau',
  'Tierärztliche Leistungen',
  'Tierfutterherstellung',
  'Tiermedizin',
  'Tonstudios',
  'Tourismus und Freizeit',
  'Training und Support für IT-Systeme',
  'Transport, Logistik, Lieferkette und Lagerhaltung',
  'Transportprogramme',
  'Transportwesen & Bahnverkehr',
  'Treuhand- und Vermögensverwaltung',
  'Übersetzung und Lokalisierung',
  'Übertragung, Steuerung und Verteilung von Strom',
  'Umweltdienstleistungen',
  'Umweltqualitätsprogramme',
  'Unterhaltung',
  'Unterhaltungselektronik',
  'Unternehmen für Gebäudeausrüstung',
  'Unternehmen für Gebäudestruktur und Außenkonstruktion',
  'Unternehmensberatung',
  'Veranstaltungsdienste',
  'Vergnügungsparks und Spielhallen',
  'Verlagswesen für Bücher und Zeitschriften',
  'Verleih von Konsumgütern',
  'Vermessungs- und Kartierungsdienste',
  'Vermietung von Gewerbeimmobilien',
  'Vermietung von gewerblicher und industrieller Ausrüstung',
  'Vermietung von Immobilien und Anlagen',
  'Vermietung von Wohnimmobilien',
  'Vermittlung von Führungskräften',
  'Verpackungsindustrie',
  'Versicherungs- und Arbeitnehmerleistungen',
  'Versicherungsagenturen',
  'Versicherungsträger',
  'Versicherungswesen',
  'Versorgungsdienstleistungen',
  'Versorgungsverwaltung',
  'Verteidigung & Raumfahrt',
  'Verwaltung von Luft-, Wasser- und Abfallprogrammen',
  'Verwaltungs- und Supportdienstleistungen',
  'Viehwirtschaft',
  'Viehwirtschaft und Fischerei',
  'Wagniskapital- und Private-Equity-Auftraggeber',
  'Wartung gewerblicher und industrieller Maschinen',
  'Wartung von Elektronik- und Präzisionsgeräten',
  'Wäscherei und Textilreinigung',
  'Wasser- und Abwasserwirtschaft, Dampf und Klimaanlagen',
  'Wasserversorgung und Bewässerungssysteme',
  'Weine und Spirituosen',
  'Weingüter',
  'Weiterbildung und Coaching',
  'Wellness und Fitness',
  'Weltraumforschung und -technologie',
  'Werbedienstleistungen',
  'Wertpapier- und Warenbörsen',
  'Wirtschaftsnachrichten und -informationen',
  'Wirtschaftsprogramme',
  'Wohnprogramme',
  'Wohnungsbau',
  'Wohnungsbau und Gemeindeentwicklung',
  'Zahnärzte',
  'Zeitarbeitsdienstleistungen',
  'Zeitschriftenverlage',
  'Zeitungsverlage',
  'Zirkusse und Zaubershows',
  'Zivilgesellschaftliche und soziale Organisationen',
  'Zoos und botanische Gärten',
  'Zucker- und Süßwarenherstellung',
  'Zuschauersport',
];
